import React, { Component } from "react";
import Renderwelcomescreen from "./welcome-screen";
import { SIDE_NAV_ITEMS } from "../../api-constant";
import NewNavBar from "../NavBar/Navbar";
import Sidebar from "../Sidebar/sidebar";
import { withRouter } from "react-router";
import axios from "axios";
import addAccessTokenToUrl from "../../Utils/Axios/addTokenToUrl";
import ResponsiveSidebar from "../Sidebar/Responsive/SideBar";
import ResponsiveWelcome from "./Responsive/Welcome";
import moment from "moment";
import Navbar from "../../../_components/common/Navbar";
const currentDate = moment().format("YYYY-MM-DD");
const calcWidth = window.innerWidth;
export class Renderuserwelcome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSideNav: SIDE_NAV_ITEMS[0].id,
      sidebarOpen: false,
      enableNotification: false,
      instrument_id: "",
      user_id: "",
      uid: "",
      participant__id: "",
      instrumentMultiRater: "",
      organisation: "",
      seller: "",
      userDetails: null,
      invitationDetails: null,
      completedCount: "",
      assessmentType: "",
      assessmentImage: '',
    };
  }

  handleNotification = () => {
    this.setState({
      enableNotification: !this.state.enableNotification,
    });
  };
  componentDidMount() {
    const instrument = this.props.match.params.instrument_id;
    const user = this.props.match.params.id;
    const participant = this.props.match.params.participant__id;
    const multiRater = this.props.match.params.instrument__is_multi_rater;
    const userOrg = this.props.match.params.organisation;
    const userSeller = this.props.match.params.seller;
    const assessmentCompletedCount = this.props.match.params
      .assessmentCompletedCount;
    const assessmentType = this.props.match.params.assessmentType;

    /* handle api call here */
    axios
      .get(addAccessTokenToUrl("/assessments/user/active/assessments/"))
      .then((response) => {
        if (assessmentType == "assessment") {
          const userDetails = response.data.user_assessments.find((i) => {
            return i.id == user;
          });
          this.setState({
            userDetails,
          });
        } else {
          const invitationDetails = response.data.my_inivation.find((i) => {
            return i.user_assessment__id == user;
          });
          this.setState({
            invitationDetails,
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
    this.setState({
      instrument_id: instrument,
      user_id: user,
      uid: user,
      participant__id: participant,
      instrumentMultiRater: multiRater,
      organisation: userOrg,
      seller: userSeller,
      completedCount: assessmentCompletedCount,
      assessmentType: assessmentType,

    });
  }

  onSetSidebarOpen = (open) => {
    this.setState({
      sidebarOpen: open,
    });
  };
  handleCloseNotification = () => {
    this.setState({
      enableNotification: false
    })
  }

  render() {
    const { userDetails, invitationDetails } = this.state;
    const userType = localStorage.getItem('usertype') || "";
    return (
      <div>
        {userType.includes("organisation_admin") || userType.includes("seller_admin") ? (
          <Navbar />
        ) : (

          <NewNavBar
            enableNotification={this.state.enableNotification}
            handleNotification={this.handleNotification}
            handleCloseNotification={this.handleCloseNotification}
          />

        )}


        {!userType.includes("organisation_admin") && !userType.includes("seller_admin") ? (
          <Sidebar
            items={SIDE_NAV_ITEMS}
            selectedSideNav={this.state.selectedSideNav}
          />
        ) : null}

        {!userType.includes("organisation_admin") && !userType.includes("seller_admin") ? (
          <ResponsiveSidebar
            items={SIDE_NAV_ITEMS}
            selectedSideNav={this.state.selectedSideNav}
            sidebarOpen={this.state.sidebarOpen}
            onSetSidebarOpen={this.onSetSidebarOpen}
          />
        ) : null}
        {calcWidth <= 767 ? (
          this.state.assessmentType == "assessment" ? (
            userDetails && (
              <ResponsiveWelcome
                user_id={this.state.user_id}
                uid={this.state.uid}
                name={userDetails.participant__full_name}
                subtitle="Complete Your Self-Assessment"
                instrumentHeaderText={
                  userDetails.instrument__dashboard_header_text
                }
                expired={currentDate > userDetails.expiry_date}
                expiryDate={userDetails.expiry_date}
                startLink={`/new/app/selfassessment/${this.state.instrument_id}/${this.state.user_id}/${this.state.organisation}/${this.state.seller}/${this.state.participant__id}/${this.state.instrumentMultiRater}/${this.state.completedCount}/assessment`}
                assessmentType={this.state.assessmentType}
                InstrumentImage={userDetails.instrument__instrument_image}
              />
            ))
            : (invitationDetails && (
              <ResponsiveWelcome
                user_id={this.state.user_id}
                uid={this.state.uid}
                name={invitationDetails.respondent__full_name}
                inviteeName={
                  invitationDetails.user_assessment__participant__full_name
                }
                subtitle={`Complete ${invitationDetails.user_assessment__participant__full_name}'s Assessment`}
                instrumentHeaderText={invitationDetails.user_assessment__instrument__instrument_name}
                expired={
                  currentDate > invitationDetails.user_assessment__expiry_date
                }
                expiryDate={invitationDetails.user_assessment__expiry_date}
                startLink={`/new/app/selfassessment/${this.state.instrument_id}/${this.state.user_id}/${this.state.organisation}/${this.state.seller}/${this.state.participant__id}/${this.state.instrumentMultiRater}/${this.state.completedCount}/invitations`}
                assessmentType={this.state.assessmentType}
                InstrumentImage={invitationDetails.user_assessment__instrument__instrument_image}

              />
            ))
        ) : this.state.assessmentType == "assessment" ? (
          userDetails && (
            <Renderwelcomescreen
              user_id={this.state.user_id}
              uid={this.state.uid}
              name={userDetails.participant__full_name}
              subtitle="Complete Your Self-Assessment"
              instrumentHeaderText={
                userDetails.instrument__dashboard_header_text
              }
              expired={currentDate > userDetails.expiry_date}
              expiryDate={userDetails.expiry_date}
              startLink={`/new/app/selfassessment/${this.state.instrument_id}/${this.state.user_id}/${this.state.organisation}/${this.state.seller}/${this.state.participant__id}/${this.state.instrumentMultiRater}/${this.state.completedCount}/assessment`}
              assessmentType={this.state.assessmentType}
              InstrumentImage={userDetails.instrument__instrument_image}
            />
          )
        ) : (
          invitationDetails && (
            <Renderwelcomescreen
              user_id={this.state.user_id}
              uid={this.state.uid}
              name={invitationDetails.respondent__full_name}
              inviteeName={
                invitationDetails.user_assessment__participant__full_name
              }
              subtitle={`Complete ${invitationDetails.user_assessment__participant__full_name}'s Assessment`}
              instrumentHeaderText={invitationDetails.user_assessment__instrument__instrument_name}
              expired={
                currentDate > invitationDetails.user_assessment__expiry_date
              }
              expiryDate={invitationDetails.user_assessment__expiry_date}
              startLink={`/new/app/selfassessment/${this.state.instrument_id}/${this.state.user_id}/${this.state.organisation}/${this.state.seller}/${this.state.participant__id}/${this.state.instrumentMultiRater}/${this.state.completedCount}/invitations`}
              assessmentType={this.state.assessmentType}
              InstrumentImage={invitationDetails.user_assessment__instrument__instrument_image}

            />
          )
        )}
      </div>
    );
  }
}

export default withRouter(Renderuserwelcome);



// WEBPACK FOOTER //
// ./src/new/Components/Welcome/index.jsx